import { useAttributesHandler } from '@townsquare/analytics/attributes-handler';
import { useRouterActions } from '@townsquare/router/primitives/actions';
import { teamProfileRoute } from '@townsquare/routes/team-profile';
import { createSearchParamsFromCurrentUrl } from '@townsquare/search-params';

import { useRoute } from './router/hooks';

export const AnalyticAttributeHandler = () => {
	const { setQueryParams } = useRouterActions();
	const route = useRoute();

	useAttributesHandler(
		route.path,
		createSearchParamsFromCurrentUrl(),
		setQueryParams,
		/**
		 * https://product-fabric.atlassian.net/browse/PTC-6958
		 * The directory component expects the src field, it handles removing the
		 * URL search param.
		 **/
		route.name === teamProfileRoute.name,
	);

	return null;
};
